import api from './api';

export const authService = {
  async register(userData) {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  async login(credentials) {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  async forgotPassword(email) {
    const response = await api.post('/auth/forgotpassword', { email });
    return response.data;
  },

  async resetPassword(token, password) {
    const response = await api.put(`/auth/resetpassword/${token}`, { password });
    return response.data;
  },

  async getProfile() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};